import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCta } from '../SectionCta';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-paper px-4 py-16 sm:py-24" data-id="element-151" data-mp="122vfsou9r9tp">
      <div className="mx-auto max-w-3xl" data-id="element-152" data-mp="1ptip9eju27id">
        <div id="faq" data-id="element-153" data-mp="1puk2npobn639">
          <SectionHeading title="Frequently asked questions" data-id="element-154" data-mp="1urtxxlye6bz0" />
        </div>

        <div className="mt-10 space-y-3" data-id="element-155" data-mp="1ut557vr1q1uv">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="rounded-2xl bg-white ring-1 ring-ink/10" data-id="element-156" data-mp="1l0pn8yfr1d9z" data-mpi={i}>
                <h3 data-id="element-157" data-mp="28qjwl60v0jph">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left font-display text-[17px] font-extrabold leading-snug text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-aqua sm:text-lg" data-id="element-158" data-mp="28q0mgbhgazm0">
                    {f.q}
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-cta text-navy-950' : 'bg-paper text-ink'}`} data-id="element-159" data-mp="2toabp9bncenp">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-160" data-mp="3he4oxrzvo58h" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-161" data-mp="1n0d7457eaf1y">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-162" data-mp="1i1s8ga7sk3fm">
                      <p className="px-5 pb-5 leading-relaxed text-ink/75" data-id="element-163" data-mp="2lpfg9x2fpf7i">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCta label="I’m ready — get my roadmap for $27" data-id="element-164" data-mp="2uplslfmec953" />
      </div>
    </section>;
}